'use strict'

export let english={
  general: {
    approach: "Approach",
    controls: "project controls",
    lesson: "Lesson",
    stage: "Stage",
    statement: {
      effect: "effect",
      because: "because",
      event: "event",
      thisWasCausedBy: "This was caused by",
      cause: "cause"
    },
    hours: "Hours (h)",
    expences: "Expenses",
    investment: "Investment",
    total: "Total",
    stageMenu: {
      stageActions: "Stage actions",
      back:" Back",
      move: "Move",
      edit: "Edit",
      selectPhase: "Select phase",
      noPhase: "no phase",
      cancelMove: "Cancel Move",
      requestApproval: "Request Approval",
      approveStage: "Approve Stage",
      retractRequest: "Retract Approval Request",
      endStageReport: "Create End Stage Report",
      raiseException: "Raise Exception",
      registerActuals: "Register actuals",
      prepareClosure: "Prepare project closure",
      changesToApprovedStage: "You have made changes to an already approved stage plan. It will automatically be saved as a new approved version when an exception plan is approved."
    },
    stagePlan: {
      title: "Stage plan",
      budget: "Budget",
      schedule: "Schedule",
      startDate: "Start date",
      endDate: "End date",
      timeTolerance: "Tolerance",
      projectPhase: "Project",
      totalPhase: "Total Project",
      totalStagePrefix: "Total",
      actions: {
        confirmDelete: "Do you want to delete this stage?"
      }
    },
    lessons: {
      onlyProject: "Show only lessons applied on this project",
      source: "Source",
      appliedIn: "Applied in",
      actions: {
        applyLesson: "Apply lesson",
        unapplyLesson: "Unapply lesson",
        editLesson: "Edit lesson",
        confirmDelete: "Do you want to delete this output?"
      },
      keywords: {
        title: "And containing keywords",
        description: "Keywords. Separate by comma (,)"
      },
      filterOptions: {
        time: {
          options: {
            lessThan12Months: "Newer than 12 months",
            oneToThreeYears: "Between 1 and 3 years",
            threeToFiveYears: "Between 3 and 5 years",
            moreThanFiveYears: "Older than 5 years"
          }
        }
      }
    },
    currency: "The currency used in this project is {currency}. You can change the project´s currency in ",
    projectPropertiesLink: "Project Properties",
    stagePlanCurrency: "Cost is shown in {currency}.",
    actuals: "Actual values",
    showingActuals: "Actual values are recorded",
    projectIsCompleted: "Project is completed",
    closureInProgress: "Project closure is in progress",
    phaseTransition: {
      stageOutsidePhases: "Phase transition is disabled, due to stage(s) outside phases.",
      requestToStart: "Request to start",
      projectNotStarted: "Project not started",
      requestComments: "Request Comments",
      readMore: "Read more about",
      cancel: "Cancel",
      submitRequest: "Submit Request",
      requestPending: "Requested to start",
      retractRequest: "Retract Request",
      approveRequest: "Approve Request",
      currentPhase: "Current Phase",
      requestToEnd: "Request to end",
      prepareClosure: "Prepare project closure"
    },
    exceptionPlan: {
      title: "Exception plan",
      readMore: "Read more...",
      approve: "Approve",
      exceptionReport: "Exception Report",
      baselinePlan: "Baseline Plan",
      beforeExceptionAproval: "before exception approval",
      afterExceptionApproval: "after exception approval",
      stageNotFound: "<stage not found>",
      update: "Update",
      requestApproval: "Request Approval",
      cancel: "Cancel",
      missingExceptionReport: "Reference to Exception Report is missing.",
      newBaselinePlan: "New baseline plan",
      fields: {
        summary: {
          title: "Exception Plan Summary",
          help: "What is the cause of the deviation from the agreed plan? What is the consequence? What is the main differences between the exception plan and the currently approved baseline?.",
          description: "Summarize cause and consequence of the exception, how the exception plan differs from existing baseline"
        },
        level: {
          title: "Exception Plan Level",
          options: {
            stage: { title: "Stage" },
            phase: { title: "Phase" },
            project: { title: "Project" }
          }
        },
        report: {
          title: "Exception Report",
          empty: "-- select exception report --"
        }
      }
    },
    baselineHistory: {
      title: "Baseline History",
      close: "Close History",
      hideDetails: "Hide details",
      header: {
        approvedPID: "Approved PID",
        approvedStage: "Approved Stage",
        unknown: "unknown baseline",
        exception: {
          stage: "Stage Exception",
          phase: "Phase Exception",
          project: "Project Exception",
          unknown: "unknown exception"
        }
      },
      noBaseline: "There is no baseline history for this project. The first baseline is set when a Project Initiation Document or Stage Plan is approved.",
      loadingHistory: "Loading history...",
      errorOccuredDurligLoading: "An error occured loading history",
      entry: {
        approvedPID: "Approved Project Initiation Document",
        baselinePlan: "Baseline plan",
        newBaselinePlan: "New baseline plan",
        beforePIDApproval: "before PID approval",
        afterPIDApproval: "after PID approval",
        approvedStagePlan: "Approved stage plan",
        beforeStageApproval: "before stage approval",
        afterStageApproval: "after initial stage approval",
        unknownBaseline: "Unknown baseline type"
      }
    }
  },
  planApproach: {
    title: "Project Approach",
    description: "The project approach is describing in which way the project work will be done. The approach should clarify methods of working, manning approach, technical and regulatory strategies and other relevant aspects influencing how the project will be organized and executed.",
    fields: {
      methods: {
        title: "Methods",
        help: `Any tailoring to project method? What will be scaled down or not used, and why?
          Any specific methodology or technical method to be used?
          Any deviations to Standard Operating Procedures or guidelines?
          Will this project go through a set of defined life-cycle phases?
          Any guidelines, standards practices used?`,
        description: "Describe the tailoring of the project method and any specialist/development/production method or process to be applied for this project."
      },
      resources: {
        title: "Resources",
        help: `Working with partners? If so, who will do what?
          Using internal or external teams or both? If so, who will do what?
          How will resources be financed? Strict or loose resource deployment?`,
        description: "Describe how we will get the needed people, equipment and money to get the project done."
      },
      technology: {
        title: "Technology",
        help: `Any specific technology to be used, or how is technology platform to be selected?
          Will it be built on off-the-shelf components or custom-designed?
          Any specific production site or method selected, or how will it be selected?
          Any regulatory strategy selected, or how will it be selected?`,
        description: "Describe the technology to be used or to build on, and the regulatory strategy relevant for the selected technology."
      },
      rollOut: {
        title: "Roll out strategy",
        help: `Is this a temporary “stop-gap” or “ever lasting” solution?
          Any staging of releases? Updates to come? Where to role out/distribute first and last?
          Announce late or early to receivers/users/market – and why?`,
        description: "Describe the launch, roll out, or distribution strategy for the end product."
      },
      other: {
        title: "Other",
        description: "Any thing else about how the work of the project will be approached?"
      }
    }
  },
  schedule: {
    title: "Schedule",
    fields: {
      schedule: {
        columnHeaders: {
          stage: {title: "Stage"},
          time: {title: "Time"},
          cost: {title: "Cost"}
        },
        columns: {
          name: { title:""},
          start: { title:"Start" },
          end: { title: "End" },
          timeTolerance: { title: "Tolerance", note: "Time tolerance units: Days = Business Days, Weeks = Work weeks" },
          hours: { title: "Hours (h)" },
          expences: { title: "Expenses" },
          investments: { title: "Investments" },
          sum: { title: "Sum" },
          costTolerance: { title: "Tolerance" }
        },
        options: {
          addEntry: { title: "+ Add stage" }
        }
      }
    }
  },
  lessons: {
    title: "Lessons",
    fields: {
      lessonLog: {
        title:"Lessons",
        columns: {
          no: { title:"Id" },
          title: { title: "Title" },
          source: { title: "Source" },
          priorityLabel: { title: "Priority" },
          recommendations: { title:"Recommendations" }
        },
        options: {
          addEntry: {
            title: "Add lesson"
          }
        }
      }
    }
  },
  summary: {
    title: "Summary",
    fields: {
      title: {
        title: "Title",
        help: "Short summary of the lesson",
        description: "Descriptive title"
      },
      type: {
        title: "Lesson Type",
        help: `Project – only applies to this project
Programme – applies to the programme which this project is part of
Portfolio – applies to the portfolio which this project is part of
Corporate – applies to all projects`,
        options: {
          project: "Project",
          program: "Programme",
          portfolio: "Portfolio",
          corporate: "Corporate"
        }
      },
      priority: {
        title: "Lesson Priority",
        help: `If this lesson is ignored later in the project or in other projects, how significant will the effect be on the project’s objectives?`,
        options: {
          high: "High",
          medium: "Medium",
          low: "Low"
        }
      }
    }
  },
  detail: {
    title: "Details",
    fields: {
      cause: {
        title: "Cause",
        help: `What triggered the event to occur? What was the situation that gave rise to the lesson. Example: technical requirement documentation was not complete`,
        description: "Describe the source of the lesson."
      },
      event: {
        title: "Event",
        help: `What event was triggered by the cause. Example: the technical design work couldn’t start`,
        description: "Describe the event that caused an impact on the project."
      },
      effect: {
        title: "Effect",
        help: `What was the impact, and what were the consequences for the project’s objectives? Example: the project was delayed by two months`,
        description: "Explain the impact(s) on the project objectives."
      },
      description: {
        title: "Detailed Description",
        description: "Describe relevant background, context and facts related to the lesson",
        help: `What information is relevant for someone who consider to apply this lesson? Any additional background information or context? Are there any quantified statistics, measurements or facts related to the lesson?`
      }
    }
  },
  followUp: {
    title: "Follow up",
    fields: {
      indicators: {
        title: "Early warning indicators",
        help: `What triggers should be used to focus attention on this particular area in the future?
          Under which circumstances should this lesson be applied to avoid negative impact on the project?
          Was this previously identified as a risk?`,
        description: "Describe the indicators which should trigger application of this lesson"
      },
      recommendations: {
        title: "Recommendations",
        help: `If these circumstances (the early warning indicators) should reappear, what is then important to do?
          What is your advice for the future?`,
        description: "Give a recommendation on what to do when this lesson is applied"
      }
    }
  },
  projectControls: {
    title: "Project Controls",
    description: "Project Control defines how the Project Board will maintain enough control of the project and how the Project Manager will maintain sufficient control of work managed by the Team Managers.",
    fields: {
      projectControls: {
        title: "Project Controls",
        help: `What is the frequency and format of communication between Project Manager and Project Board?
          What is the frequency and format of communication between Team Manager and Project Manager?
          Is there any guidance on length of stages? Short stages give more control, but also more overhead.
          When is something escalated for information, for decision or for guidance? When is a flag raised?
          What tools and processes are used to escalate for information, decisions or guidance?`,
        description: "Describe the project level controls needed such as monitoring, escalation and reporting formats and frequency"
      }
    }
  },
  stageDescription: {
    frontPage: "Front Page",
    title: "Description",
    fields: {
      identifier: {
        title: 'Identifier',
        description: '(not in use)'
      },
      name: {
        title: "Name",
        description: "Name of the stage"
      },
      description: {
        title: "Description",
        help: `Where in the project’s lifecycle is this stage (if relevant), and what type of work is done (analysis, design, test etc)?
          What is the goal of this stage?
          Briefly summarized, what will this stage include and how will it be done?Which project (and if relevant which lifecycle phase) is this stage a part of?`,
        description: "Short description of what this stage is"
      },
      prerequisite: {
        title: "Plan Prerequisite",
        help: `Are there already existing documents or other inputs this plan is built on or this stage will need to start executing?
          Any deliverables, events or decisions to be concluded for this plan to start?`,
        description: "Describe what must be in place to start execution of this stage"
      },
      method: {
        title: "Method",
        values: {
          product: "Product Management",
          project: "Project Managament"
        }
      }
    }
  },
  stageContext: {
    title: "Context",
    fields: {
      externalDependencies: {
        title: "External Dependencies",
        help: `Any ongoing activities outside this project that may influence the stage during execution?
          Are you dependening on other projects to deliver output or release resources during the execution of this stage?
          Any actions, events or decisions outside this project's influence that might influence the stage execution?`,
        description: "Describe external dependencies"
      },
      assumptions: {
        title: "Planning Assumptions",
        help: `Are there any assumptions made in the plan on access to resources, tools or competencies?
          Are there made any assumptions or completeness of required input to this stage`,
        description: "Describe planning assumptions"
      },
      stageApproach: {
        title: "Stage Approach",
        help: `Any specific methodology or technical method to be used in this stage?
          Any guidelines, standards practices used?
          Using internal or external teams or both? If so, who will do what?
          Any specific technology to be used in this stage?`,
        description: "Describe the delivery approache(s) for this stage"
      },
      lessonsIncorporated: {
        title: "Lessons Incorporated",
        help: `Are relevant lessons learned from previous stages used in the planning of this stage?
          Are relevant lessons learned from other projects used in the planning of this stage?`,
        description: "Describe relevant lessons incorporated in the planning and execution of this stage"
      },
      monitorAndControl: {
        title: "Monitor and Control",
        help: `What is the frequency and format of communication between Project Manager and Project Board during the stage?
          What is the frequency and format of communication between Team Manager and Project Manager?
          When is something escalated for information, for decision or for guidance? When is a flag raised?
          What tools and processes are used to escalate information, decisions or guidance?`,
        description: "Describe the stage level controls needed such as monitoring, escalation and reporting formats and frequency"
      }
    }
  },
  stageTime: {
    title: "Time",
    fields: {
      period: {
        title: "Stage period"
      },
      timeTolerance: {
        title: "Time Tolerance (value)",
        description: "In number of business days, workweeks or months"
      },
      timeToleranceUnit: {
        title: "Time Tolerance (unit)",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months"
        }
      },
      timeComments: {
        title: "Comments to Time",
        description: "Comments to the time aspect of the stage plan"
      }
    }
  },
  stageCost: {
    title: "Cost",
    fields: {
      budget: {
        title: "Stage budget",
        help: `Hours: Number of hours needed by internal staff, or hour spent by external resources where the policy is to do project accounting in hours.
          Expenses: Direct expenses received as invoices. This should normally exclude expenses filed as hours. Should not included investments.
          Investments: Capitalized costs for fixed assets
          Total: Manually calculated total cost of the stage. Usually total = hours x cost of hours + expenses + investments.`,
        columns: {
          element: { title: "Cost element" },
          cost: { title: "Cost" },
          tolerance: { title: "Tolerance" },
          comment: { title: "Comment" }
        }
      }
    }
  },
  stageScheduleScope: {
    title: "Schedule & Scope",
    fields: {
      plan: {
        title: "Stage Scehdule",
        columns: {
          workPackage: { title: "Work Package" },
          owner: { title: "Owner" },
          dueDate: { title: "Due Date" },
          status: { title: "Status" },
          comment: { title: "Comment" }
        },
        samples: [
          { workPackage: "Pilot A\n  - Prototype A\n  - Pilot site report", owner: "IT director", dueDate: "2018-12-01", status: "Completed" },
          { workPackage: "Marketing\n  - Product Webpage\n  - Launch Plan", owner: "Marketing director", dueDate: "2018-12-12", status: "Started" },
          { workPackage: "Cleaning", owner: "Donald Duck", dueDate: "2018-11-20", status: "Not Started" }
        ],
        options: {
          addEntry: { title: "+Add" }
        }
      },
      scheduleComments: {
        title: "To be Delivered",
        description: "Describe/list what will be delivered in this stage, when and by whom"
      }
    }
  },
  actuals: {
    title:"Actuals",
    fields: {
      period: {
        title: "Actual stage period"
      },
      cost: {
        title: "Actual stage cost",
        columns: {
          element: { title: "Cost element" },
          cost: { title: "Cost" },
          comment: { title: "Comment" }
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/plan/labels/english.js